import { computed, ref } from 'vue'
import { PermissionsData } from '@/types/api'

export const permissionsData = ref<PermissionsData | undefined>(undefined)

export const isUserAdmin = computed(() => {
    return permissionsData.value?.IsAdmin
})

export function setPermissionsData (permissions?: PermissionsData) {
    permissionsData.value = permissions
}
